import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RxStomp } from '@stomp/rx-stomp';
import { Message } from '@stomp/stompjs';
import { Globals } from '../globals/globals';
import { environment } from 'environments/environment';
import { RxStompConfig } from './websocket.config';
import { FrankliNotification } from '@app/models/notifications/frankli-notification.model';

// TODO: this should be removed in favor of the rx-stomp-state.d.ts
// Can't get it to pick up on it
export enum RxStompState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}

/**
 * This service is used to handle the connection and subscription for the websocket. It is used to display the
 * notifications in the navbar and the notifications component on the dashboard.
 */
@Injectable()
export class WebsocketService {
  private readonly STOMP_ENDPOINT = '/user/queue/events';

  private readonly rxStomp: RxStomp;
  private readonly stompSubscription$: Observable<Message>;

  public readonly websocketConnection$: Observable<FrankliNotification>;
  public readonly websocketConnectionState$: Observable<RxStompState>;

  constructor(public globals: Globals) {
    this.rxStomp = new RxStomp();
    this.rxStomp.configure(RxStompConfig);

    this.stompSubscription$ = this.rxStomp.watch(this.STOMP_ENDPOINT);

    this.websocketConnection$ = new Observable<FrankliNotification>(observer => {
      this.stompSubscription$.subscribe(
        (message: Message) => {
          const notification: FrankliNotification = JSON.parse(message.body);
          // ensure notification belongs to current user
          if (notification.userId === this.globals.user.id) {
            observer.next(notification);
          }
        },
        (error: unknown) => {
          console.error('Error while subscribing to websocket', error);
        },
      );
    });

    this.websocketConnectionState$ = this.rxStomp.connectionState$.asObservable();
  }

  public activate(): void {
    if (environment.mock.enabled) {
      return;
    }
    if (this.rxStomp.active) {
      return;
    }
    if (this.rxStomp.connected()) {
      return;
    }
    if (!this.globals.user) {
      return;
    }

    this.rxStomp.configure({
      brokerURL: `${environment.websocketUrl}?token=${localStorage.getItem('access_token')}`,
    });

    this.rxStomp.activate();
  }

  public deactivate(): void {
    if (!this.rxStomp.active) {
      return;
    }

    this.rxStomp.deactivate();
  }

  public getConnection$(): Observable<FrankliNotification> {
    return this.websocketConnection$;
  }

  public getConnectionState$(): Observable<RxStompState> {
    return this.websocketConnectionState$;
  }

  public testSendingWhileDeactivate(): void {
    for (let index = 0; index < 3; index++) {
      this.deactivate();
      this.activate();
    }
  }
}
